import { Fragment, useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import Sidebar from "@/features/dashboard/nav/sidebar";
import { useRouter } from "next/router";

export default function DashboardMobileDrawer({ open, setOpen }) {
  const router = useRouter();

  const closeSidebar = () => {
    setTimeout(() => setOpen(false), 200);
  };

  useEffect(() => {
    router.events.on("routeChangeComplete", closeSidebar);
    return () => {
      router.events.off("routeChangeComplete", closeSidebar);
    };
  }, [router.events]);

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-40 lg:hidden" onClose={setOpen}>
        {/* translucent overlay at the back when panel is open */}
        <Transition.Child
          as={Fragment}
          enter="transition-opacity ease-linear duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity ease-linear duration-300"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-30" />
        </Transition.Child>

        <div className="fixed inset-0 flex z-40">
          <Transition.Child
            as={Fragment}
            enter="transition ease-in-out duration-300 transform"
            enterFrom="-translate-x-full"
            enterTo="translate-x-0"
            leave="transition ease-in-out duration-300 transform"
            leaveFrom="translate-x-0"
            leaveTo="-translate-x-full"
          >
            <Dialog.Panel className="relative min-w-[300px] sm:min-w-[350px] bg-background-secondary-white shadow-xl flex flex-col overflow-y-auto">
              <div className="flex justify-end z-50">
                <button
                  type="button"
                  className="absolute top-4 right-4 p-2 rounded-full text-gray-3 ring-0 focus:outline-none"
                  onClick={() => setOpen(false)}
                >
                  <span className="sr-only">Close menu</span>
                  <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                </button>
              </div>
              <Sidebar isDrawer={true} />
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
